import { LoadingIndicator } from "@peak-security-suite/ui-elements";

export function GlobalLoading(props) {
  return (
    <div className="h-full w-full">
      <LoadingIndicator {...props} />
    </div>
  );
}

export default GlobalLoading;
